<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-form ref="CoreTimeFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>Faculty IPCR Rating Approval</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-card>
              <v-row>
                <v-col cols="12" v-if="getIsSubmitted">
                  <v-stepper alt-labels class="elevation-0">
                    <v-stepper-header>
                      <v-stepper-step
                        step="1"
                        class="pa-5"
                        :complete="
                          targetRating && targetRating.assessed_by_status == 2
                            ? true
                            : false
                        "
                        :rules="[
                          () =>
                            targetRating &&
                            targetRating.assessed_by_status != 3,
                        ]"
                        color="#6DB249"
                      >
                        {{
                          getName(
                            targetRating && targetRating.assesed_by
                              ? targetRating.assesed_by
                              : null
                          )
                        }}
                        <small>Assessed By<br /> </small>
                      </v-stepper-step>
                    </v-stepper-header>
                  </v-stepper>
                </v-col>
                <v-col cols="8" class="flex-items mt-2">
                  <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                    <v-tab
                      v-for="tab in tabList"
                      :key="tab.id"
                      @click="changeTab(tab)"
                      >{{ tab.name }}</v-tab
                    >
                  </v-tabs>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="12" class="pt-2 px-4" v-if="tab != 3">
                  <v-data-table
                    :headers="headers"
                    :items="dataItem"
                    :items-per-page="-1"
                  >
                    <template v-slot:[`item.efficiency`]="{ item }">
                      {{
                        item.facultyRating.accomplishment
                          ? "(" + item.facultyRating.accomplishment + ") "
                          : ""
                      }}
                      {{
                        item.eff_is_rated == 1
                          ? item.facultyRating.efficiency
                          : "NR"
                      }}
                    </template>
                    <template v-slot:[`item.quality`]="{ item }">
                      {{
                        item.qly_is_rated == 1
                          ? item.facultyRating.quality
                          : "NR"
                      }}
                    </template>
                    <template v-slot:[`item.timeliness`]="{ item }">
                      {{
                        item.timeliness_is_rated == 1
                          ? item.facultyRating.timeliness
                          : "NR"
                      }}
                    </template>
                    <template v-slot:[`item.remarks`]="{ item }">
                      {{ item.facultyRating.remarks }}
                    </template>

                    <!-- <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pa-4">
                        <table id="tbl_expanded">
                          <tr>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width:33%"
                            >
                              Efficiency
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width:33%"
                            >
                              Quality
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width:33%"
                            >
                              Timeliness
                            </th>
                          </tr>
                          <tr>
                            <td
                              align="center"
                              class="text-caption font-weight-bold "
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                          </tr>

                          <tbody>
                            <tr>
                              <td
                                :colspan="!item.eff_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.eff_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.e_w1
                                }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w2 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w3 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w4 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("E", item) }}
                              </td>
                              <td
                                :colspan="!item.qly_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.qly_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.q_w1
                                }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w2 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w3 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w4 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("Q", item) }}
                              </td>
                              <td
                                :colspan="!item.timeliness_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.timeliness_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.t_w1
                                }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w2 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w3 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w4 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("T", item) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </template> -->
                    <template
                      v-slot:[`item.actions`]="{ item }"
                      v-if="toPending"
                    >
                      <v-btn
                        v-if="item.pendingRemarks.length > 0"
                        x-small
                        block
                        class="my-1"
                        color="primary"
                        outlined
                        @click="viewItem(item)"
                      >
                        view remarks
                      </v-btn>
                      <v-btn
                        block
                        x-small
                        class="my-1"
                        color="red"
                        outlined
                        @click="pendingItem(item)"
                      >
                        add pending remarks
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" class="pt-2 px-4" v-if="tab == 3">
                  <v-form ref="GDriveLinkRef">
                    <div class="pa-4 rounded-lg" style="border: 1px solid grey">
                      <div class="px-2">
                        <v-btn
                          v-if="showUpdateLinkBtn"
                          color="warning"
                          class="white--text mx-2"
                          @click="showGDrive()"
                        >
                          View GDrive
                        </v-btn>
                      </div>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
              <v-row v-if="getHasData">
                <v-col
                  cols="12"
                  v-if="
                    targetRating &&
                    targetRating.isSubmitted == 1 &&
                    targetRating.assesed_by_status == 2
                  "
                >
                  <v-divider></v-divider>
                  <div class="pa-3">
                    <div class="text-h6">
                      Comments and Recommendations for Development Purposes:
                    </div>
                    <div class="text-justify text-subtitle-1">
                      {{ targetRating ? targetRating.comments : null }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-5">
            <!-- <v-fab-transition>
              <v-menu top>
                <template v-slot:activator="{ on }">
                  <v-btn color="#519043" left outlined v-on="on">
                    Remarks
                  </v-btn>
                </template>

                <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                  <v-card-title class="dialog-header  white--text">
                    <span class="text-h6">Remarks</span>
                  </v-card-title>
                  <v-card-text
                    class="py-0"
                    style="background-color:white;  height : 300px; overflow-y:auto"
                  >
                    <v-timeline dense v-if="remarksData.length > 0">
                      <v-timeline-item
                        v-for="item in remarksData"
                        :key="item.id"
                        small
                        color="#519043"
                        icon="mdi-comment-processing-outline"
                        fill-dot
                      >
                        <v-alert :value="true">
                          <div class="text-h6">
                            {{
                              $store.getters.getUserData.id ==
                              item.remarks_maker_userID
                                ? "You"
                                : item.remarks_by
                            }}
                          </div>
                          <div class="text-body-1">
                            {{ item.message }}
                          </div>
                          <div class="text-caption">
                            <i>{{ formatDate(item.created_at) }}</i>
                          </div>
                        </v-alert>
                      </v-timeline-item>
                    </v-timeline>
                    <v-timeline dense v-if="remarksData.length == 0">
                      <v-timeline-item
                        small
                        color="#519043"
                        icon="mdi-comment-processing-outline"
                        fill-dot
                      >
                        <v-alert :value="true">
                          <div class="text-body-1">
                            No remarks found.
                          </div>
                        </v-alert>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-fab-transition> -->
            <v-spacer></v-spacer>

            <v-btn
              color="red"
              v-if="!toPending"
              outlined
              @click="setToPending()"
            >
              pending
            </v-btn>
            <v-btn
              color="#519043"
              v-if="!toPending"
              class="white--text"
              @click="approve()"
            >
              Approve
            </v-btn>

            <v-btn
              color="red"
              :disabled="confirmLoading"
              v-if="toPending"
              outlined
              @click="cancelPending()"
            >
              Cancel Pending
            </v-btn>
            <v-btn
              v-if="toPending"
              color="#519043"
              class="white--text"
              :disabled="confirmLoading"
              :loading="confirmLoading"
              @click="confirmPending()"
            >
              Confirm Pending
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- remarks dialog -->
    <v-dialog v-model="addRemarksDialog" persistent max-width="600">
      <v-card color="white">
        <v-form ref="RemarksFormref" @submit.prevent>
          <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
            <span>Add Observation and Remarks </span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="addRemarksDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 400px" class="my-4"> </v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="remarksMsg"
                  :rules="[formRules.required]"
                  dense
                  placeholder="Type remarks here..."
                  outlined
                  rows="5"
                  required
                  class="rounded-lg"
                  color="#6DB249"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="addRemarksDialog = false">
              Close
            </v-btn>
            <v-btn
              color="green"
              class="white--text"
              @click="submitAsApproved()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <RemarksDialog
      :data="itemToPending"
      v-on:saveRemarks="saveRemarks"
      v-on:closeRemarks="closeRemarks"
      :type="type"
      :moduleFrom="'IPCR FACULTY RATING APPROVAL'"
    />

    <ViewRemarksTimelineDialog
      :data="list"
      v-on:closeRemarksTimeline="closeRemarksTimeline"
    />
    <WarningDialog :msg="cancelMsg" v-on:yes="yes" v-on:no="no" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="fadeAwayMessage.timeout"
    ></fade-away-message-component>
  </div>
</template>

<script>
import RemarksDialog from "../../Views/RemarksDialog.vue";
import ViewRemarksTimelineDialog from "../../Views/ViewRemarksTimelineDialog.vue";
import WarningDialog from "../../Views/WarningDialog.vue";

export default {
  components: {
    RemarksDialog,
    ViewRemarksTimelineDialog,
    WarningDialog,
  },
  props: {
    data: null,
  },
  data() {
    return {
      action: null,
      isloading: null,
      confirmSubmitDialog: false,
      confirmBtnLoading: false,
      saveLinkbtn: false,
      gdrive_link: null,
      toUpdateLink: false,
      loading: false,
      remarksData: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
        timeout: 1500,
      },
      options: {},
      itemData: null,
      expanded: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Google Drive Link" },
      ],
      ipcr_faculty_rating: null,
      curData: null,
      dataItem: [],
      targetRating: null,
      usersList: [],
      ipcr_gDriveLink: null,
      headers: [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "success_indicator",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          width: 200,
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          width: 200,
          align: "center",
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Status",
        //   value: "approval_status",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        {
          text: "Remarks",
          value: "remarks",
          align: "start",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
          width: 100,
          valign: "center",
          sortable: false,
        },
      ],
      addRemarksDialog: false,
      remarksMsg: null,
      toPending: false,
      pendingList: [],
      type: null,
      list: [],
      confirmLoading: false,
      itemToPending: null,
      cancelMsg: null,
      submitAction: null,
    };
  },
  computed: {
    getIsSubmitted() {
      return this.targetRating && this.targetRating.isSubmitted == 1;
    },

    getHasData() {
      return this.dataItem.length > 0;
    },

    showUpdateLinkBtn() {
      let show = false;
      if (this.ipcr_gDriveLink) {
        if (this.toUpdateLink) {
          show = false;
        } else {
          show = true;
        }
      }
      return show;
    },
  },
  watch: {
    data: {
      handler(data) {
        this.getHeadUsers();
        this.tab = 1;
        this.dialog = true;
        this.toPending = false;
        this.pendingList = [];
        this.activeTab = { id: 1, name: "Core Functions" };
        console.log("this is data", data);
        this.ipcr_faculty_rating = data;
        this.getGDriveLink(data.ipcr_ID);
        // this.loadRemarks(data.id);
        this.initialize();
      },
      deep: true,
    },

    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeIPCRFacultySetRatingDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeIPCRFacultySetRatingDialog");
  },
  methods: {
    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/IPCR-FACULTY-RATING", "GET").then(
          (res) => {
            if (res.data) {
              console.log("remarks", res.data);
              this.remarksData = res.data;
            }
          }
        );
      }
    },

    setHeaders() {
      let headers = [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
      ];
      let headersWAction = [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Action",
          value: "actions",
          width: 200,
          align: "center",
          sortable: false,
        },
      ];
      let support_headers = [
        {
          text: "MFO",
          value: "type",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "success_indicator",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "supp_efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "supp_quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "supp_timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
      ];

      this.headers = this.toPending ? headersWAction : headers;
      this.headers1 = support_headers;
      // ? support_headers_WAction
      // : support_headers;
    },
    setToPending() {
      this.toPending = true;
      this.setHeaders();
    },
    saveRemarks(data) {
      this.pendingList.push(data);
      console.log("calleded", this.pendingList);

      this.initialize();
    },
    closeRemarks(data) {
      this.itemToDelete = data;
    },
    closeRemarksTimeline() {
      this.list = [];
    },
    pendingItem(item) {
      this.type =
        this.tab == 1
          ? "Core Function"
          : this.tab == 2
          ? "Strategic Priority"
          : "";
      this.itemToPending = null;
      setTimeout(() => {
        this.itemToPending = item;
      }, 100);
      console.log("PENDING", item);
    },

    viewItem(item) {
      console.log(item.pendingRemarks);

      this.list = [];
      setTimeout(() => {
        this.list = item.pendingRemarks;
      }, 100);
    },
    confirmPending() {
      this.submitAction = "confirm pending";
      this.cancelMsg =
        "Are you sure you want to PENDING this? Please note that this action is irreversible.";
    },

    cancelPending() {
      this.submitAction = "cancel pending";
      if (this.pendingList.length > 0) {
        this.cancelMsg =
          "You have added pending remarks! Are you sure you want to CANCEL the Pending? Added remarks will not be saved.";
      } else {
        this.removePendingRemarks();
      }
    },

    getGDriveLink(id) {
      if (id) {
        this.axiosCall("/ipcr/getGdriveLink/" + id, "GET").then((res) => {
          if (res.data) {
            console.log("LINK", res.data);
            this.ipcr_gDriveLink = res.data;
          }
        });
      }
    },

    showGDrive() {
      let url = this.ipcr_gDriveLink.link;
      window.open(url, "_blank");
    },
    initialize() {
      this.loading = true;

      this.axiosCall(
        "/ipcr-target/getMyIPCRTargetForRating/" +
          this.ipcr_faculty_rating.ipcr_ID +
          "/" +
          this.tab,
        "GET"
      ).then((res) => {
        if (res) {
          console.log("RESPONSE", res.data);
          //   this.curData = res.data;
          this.dataItem = res.data.targets;
          this.targetRating = res.data.target_rating;
          this.loading = false;
        }
      });
    },

    getItemSuccessIndicator(item) {
      return item.efficiency_type == "percentage"
        ? item.efficiency +
            "%" +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness
        : item.efficiency +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness;
    },
    getTotal(field, item) {
      if (item) {
        let i = item.mpor;

        if (field == "E") {
          let total = 0;
          if (item.eff_is_rated) {
            if (
              i.e_w1 != null &&
              i.e_w2 != null &&
              i.e_w3 != null &&
              i.e_w4 != null
            ) {
              total += i ? (i.e_w1 ? i.e_w1 : 0) : 0;
              total += i ? (i.e_w2 ? i.e_w2 : 0) : 0;
              total += i ? (i.e_w3 ? i.e_w3 : 0) : 0;
              total += i ? (i.e_w4 ? i.e_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        } else if (field == "Q") {
          let total = 0;
          if (item.qly_is_rated) {
            if (
              i.q_w1 != null &&
              i.q_w2 != null &&
              i.q_w3 != null &&
              i.q_w4 != null
            ) {
              total += i ? (i.q_w1 ? i.q_w1 : 0) : 0;
              total += i ? (i.q_w2 ? i.q_w2 : 0) : 0;
              total += i ? (i.q_w3 ? i.q_w3 : 0) : 0;
              total += i ? (i.q_w4 ? i.q_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        } else if (field == "T") {
          let total = 0;
          if (item.timeliness_is_rated) {
            if (
              i.t_w1 != null &&
              i.t_w2 != null &&
              i.t_w3 != null &&
              i.t_w4 != null
            ) {
              total += i ? (i.t_w1 ? i.t_w1 : 0) : 0;
              total += i ? (i.t_w2 ? i.t_w2 : 0) : 0;
              total += i ? (i.t_w3 ? i.t_w3 : 0) : 0;
              total += i ? (i.t_w4 ? i.t_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        }
      }
    },
    getName(uID) {
      if (uID) {
        for (let i = 0; i < this.usersList.length; i++) {
          if (uID == this.usersList[i].usID) {
            return this.usersList[i].name;
          }
        }
      }
    },

    submitForPending() {
      this.confirmLoading = true;
      let data = {
        remarks: this.remarksMsg,
        ipcr_ID: this.data.ipcr_ID,
      };
      this.axiosCall("/ipcr/pendingFacultyRating", "POST", data).then((res) => {
        if (res.data.status == 200) {
          this.cancelMsg = null;
          this.pendingList = [];
          this.confirmLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else if (res.data.status == 400) {
          this.cancelMsg = null;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    approve() {
      this.cancelMsg =
        "Are you sure you want to APPROVE this? Please note that this action is irreversible.";
      this.submitAction = "approve";
    },

    submitAsApproved() {
      if (this.$refs.RemarksFormref.validate()) {
        this.confirmLoading = true;
        let data = {
          remarks: this.remarksMsg,
          ipcr_ID: this.data.ipcr_ID,
        };
        this.axiosCall("/ipcr/approveFacultyRating  ", "POST", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.confirmLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.addRemarksDialog = false;
              this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        );
      }
    },

    removePendingRemarks() {
      let data = {
        list: JSON.stringify(this.pendingList),
      };
      this.axiosCall("/remarks/remove-pending-remarks", "POST", data).then(
        (res) => {
          if (res.data.status == 200) {
            this.cancelMsg = null;
            this.toPending = false;
            this.pendingList = [];
            this.setHeaders();
            this.initialize();
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "Pending Cancelled!";
            // this.closeD();
          } else if (res.data.status == 400) {
            this.cancelMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      );
    },

    yes() {
      if (this.submitAction == "cancel pending") {
        this.removePendingRemarks();
      }
      if (this.submitAction == "confirm pending") {
        this.submitForPending();
      }
      if (this.submitAction == "approve") {
        this.cancelMsg = null;
        this.addRemarksDialog = true;
        this.remarksMsg = null;
      }
    },
    no() {
      this.submitAction = null;
      this.cancelMsg = null;
    },

    closeD() {
      if (this.pendingList.length > 0) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "warning";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.timeout = 5000;
        this.fadeAwayMessage.message =
          "You have added pending remarks! Please click the CANCEL PENDING button to cancel the pending process.";
      } else {
        this.eventHub.$emit("closeIPCRFacultyRatingApprovalDialog", false);
        this.dialog = false;
      }
    },

    // addRate(item) {
    //   console.log("RATE ITEM", item);
    //   let setting = {
    //     mfo: item.mfo,
    //     target_for: item.target_for,
    //     eff_is_rated: item.eff_is_rated,
    //     eff_rating_scale: [],
    //     qly_is_rated: item.qly_is_rated,
    //     qly_rating_scale: [],
    //     timeliness_is_rated: item.timeliness_is_rated,
    //     timeliness_rating_scale: [],
    //   };
    //   if (item.facultyRatingSettings) {
    //     Object.assign(item.facultyRatingSettings, {
    //       target_for: item.target_for,
    //     });
    //   }
    //   this.itemData = {
    //     facultyRating: item.facultyRating,
    //     facultyRatingSettings: item.facultyRatingSettings
    //       ? item.facultyRatingSettings
    //       : setting,
    //   };
    //   // console.log("imteData", item);
    //   this.action = "Add";
    // },
    // updateRate(item) {
    //   console.log("RATE ITEM", item);
    //   let setting = {
    //     mfo: item.mfo,
    //     target_for: item.target_for,
    //     eff_is_rated: item.eff_is_rated,
    //     eff_rating_scale: [],
    //     qly_is_rated: item.qly_is_rated,
    //     qly_rating_scale: [],
    //     timeliness_is_rated: item.timeliness_is_rated,
    //     timeliness_rating_scale: [],
    //   };
    //   if (item.facultyRatingSettings) {
    //     Object.assign(item.facultyRatingSettings, {
    //       target_for: item.target_for,
    //     });
    //   }

    //   this.itemData = {
    //     facultyRating: item.facultyRating,
    //     facultyRatingSettings: item.facultyRatingSettings
    //       ? item.facultyRatingSettings
    //       : setting,
    //   };
    //   this.action = "Update";
    // },
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    submit() {
      this.confirmSubmitDialog = true;
    },

    // saveLink() {
    //   this.saveLinkbtn = true;
    //   if (this.$refs.GDriveLinkRef.validate()) {
    //     if (this.gdrive_link && this.ipcr) {
    //       let data = {
    //         id: this.ipcr_gDriveLink ? this.ipcr_gDriveLink.id : null,
    //         link: this.gdrive_link,
    //       };
    //       this.axiosCall(
    //         "/ipcr/setFacultyIPCRGDriveLink/" + this.ipcr.id,
    //         "PATCH",
    //         data
    //       ).then((res) => {
    //         if (res.data.status == 200) {
    //           this.saveLinkbtn = false;

    //           this.fadeAwayMessage.show = true;
    //           this.fadeAwayMessage.type = "success";
    //           this.fadeAwayMessage.header = "System Message";
    //           this.fadeAwayMessage.message = res.data.msg;
    //           this.getGDriveLink(this.ipcr.id);
    //         } else {
    //           this.fadeAwayMessage.show = true;
    //           this.fadeAwayMessage.type = "error";
    //           this.fadeAwayMessage.header = "System Message";
    //           this.fadeAwayMessage.message = res.data.msg;
    //         }
    //       });
    //     } else {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message =
    //         "Please paste the link of your Google Drive as attachments.";
    //     }
    //   } else {
    //     this.saveLinkbtn = false;
    //   }
    // },

    // updateLink() {
    //   this.toUpdateLink = true;
    // },

    // undoUpdate() {
    //   this.gdrive_link = null;
    //   this.toUpdateLink = false;
    // },

    // cancelConfirm() {
    //   this.confirmSubmitDialog = false;
    // },
    // confirmSubmit() {
    //   this.confirmBtnLoading = true;

    //   this.axiosCall(
    //     "/ipcr-target/submitIpcrFacultyRating/" + this.targetRating.id,
    //     "PATCH"
    //   ).then((res) => {
    //     if (res) {
    //       this.confirmBtnLoading = false;

    //       if (res.data.status == 200) {
    //         this.confirmSubmitDialog = false;
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "success";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message = res.data.msg;
    //         this.initialize();
    //       } else if (res.data.status == 400) {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message = res.data.msg;
    //       }
    //     }
    //   });
    // },

    getHeadUsers() {
      this.axiosCall(
        "/user-details/getUsersHeadProgChairAbove_Office",
        "GET"
      ).then((res) => {
        let data = res.data;
        data.forEach((element, i) => {
          data[i].name = this.toTitleCase(element.name);
        });
        this.usersList = data;
      });
    },
  },
};
</script>
<style scoped>
#tbl_expanded {
  border-collapse: collapse;
  width: 100%;
  padding: 5px;
}
#tbl_expanded table,
#tbl_expanded th,
#tbl_expanded td {
  border: 2px solid grey;
}
</style>
